<div class="row my-5">
	<div class="row mt-2 mb-4">
		<span class="theme-main-color fw-bold fs-3 col">
			Statistiques de la semaine {{ weekNumber }}</span
		>
		<a
			*ngIf="statsDataAvailable && globalStats.numberFormation > 0"
			(click)="voirPlus()"
			class="btn border rounded-pill theme-white-button col-4"
			[routerLink]="'/reports'"
			><i class="bi bi-reception-3 fs-4 me-2" aria-hidden="true"></i>Voir les
			statistiques complètes</a
		>
	</div>
	<div
		*ngIf="statsDataAvailable && globalStats.numberFormation > 0"
		class="row mt-4"
	>
		<div class="col-4">
			<div class="row text-center mb-2">
				<span class="theme-main-color fw-bold">
					Taux de satisfaction des spécialités
				</span>
			</div>
			<div class="row" *ngIf="true">
				<div *ngIf="lsfStats?.numberFormation > 0" class="col-12 col-lg-4">
					<div echarts [options]="chartOptionSatisfactionLSF"></div>
				</div>
				<div *ngIf="lpcStats?.numberFormation > 0" class="col-12 col-lg-4">
					<div echarts [options]="chartOptionSatisfactionLPC"></div>
				</div>
				<div *ngIf="pdnStats?.numberFormation > 0" class="col-12 col-lg-4">
					<div echarts [options]="chartOptionSatisfactionPDN"></div>
				</div>
			</div>
			<div class="row" *ngIf="isSAAD">
				<div class="col col-lg-8">
					<div echarts [options]="chartOptionSatisfactionSAAD"></div>
				</div>
			</div>
		</div>
		<div class="col-4">
			<div class="row text-center mb-2">
				<span class="theme-main-color fw-bold"
					>Distance parcourue en moyenne (km)</span
				>
			</div>
			<div class="row">
				<div echarts [options]="chartOptionDistance"></div>
			</div>
		</div>
		<div class="col-4">
			<div class="row text-center mb-2">
				<span class="theme-main-color fw-bold">Temps de travail (heure)</span>
			</div>
			<div class="row">
				<div echarts [options]="chartOptionTempsTravail"></div>
			</div>
		</div>
	</div>
	<div>
		<app-no-data-available
			*ngIf="
				(statsDataAvailable && globalStats.numberFormation === 0) ||
				!statsDataAvailable
			"
		></app-no-data-available>
	</div>
</div>
